<template>
  <div  id="page" class="main-container">
    <router-view />
  </div>
  <div  id="scroll-to-top" class="vamtam-scroll-to-top">
    <div  id="scroll-to-top-text">top</div>
  </div>
</template>
<script>
  // import HeaderComponent from '@/components/layouts/HeaderComponent.vue';
  // import FooterComponent from '@/components/layouts/FooterComponent.vue';

  export default {
    components: {
      // HeaderComponent,
      // FooterComponent,
    },
    watch: {
    },
    mounted() {
      document.querySelectorAll('img[data-lazy-src]').forEach(img => {
        img.src = img.dataset.lazySrc
      })
    },
  }
</script>

<style>
  .elementor-invisible {
    opacity: 1 !important;
    transform: none !important;
  }

  .elementor-section {
    overflow: visible !important;
  }

  /* img[data-lazy-src] {
    content: attr(data-lazy-src);
  } */
</style>
